export const SCRIPT_ALLOCATION_ERROR = 'SCRIPT_ALLOCATION_ERROR';
export const SCRIPT_ALLOCATION_GET = 'GET_SCRIPT_ALLOCATION_INIT';
export const SCRIPT_ALLOCATION_GET_ALL = 'SCRIPT_ALLOCATION_GET_ALL';
export const SCRIPT_ALLOCATION_COUNT = 'GET_SCRIPT_ALLOCATION_COUNT';
export const SCRIPT_ALLOCATION_CLEAR_ALL_UPDATES = 'SCRIPT_ALLOCATION_CLEAR_ALL_UPDATES';
